import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29dfb956&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkbox: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/Checkbox/index.vue').default,GenericButton: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/GenericButton/index.vue').default,Modal: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/Modal/index.vue').default})
